import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/Home.vue'),
    meta: { isAuthPage: true }
  },
  {
    path: '/signin',
    name: 'sign-in',
    component: () => import('@/views/Auth/SignIn.vue'),
    meta: { isAuthPage: true }
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/Auth/Register.vue'),
    meta: { isAuthPage: true }
  },
  {
    path: '/password-reset',
    name: 'password-reset',
    component: () => import('@/views/Auth/PasswordReset.vue'),
    meta: { isAuthPage: true }
  },
  {
    path: '/password-reset/confirm',
    name: 'password-reset-confirm',
    component: () => import('@/views/Auth/PasswordResetConfirm.vue'),
    meta: { isAuthPage: true }
  },
  { // redirect old links
    path: '/ai-trainer/:id',
    name: 'ai-trainer',
    redirect: '/tasks/:id/training'
  },
  {
    path: '/tasks',
    name: 'tasks',
    component: () => import('@/views/Tasks/Tasks.vue')
  },
  { // redirect old task detail links to tasks list
    path: '/tasks/:id',
    name: 'task',
    redirect: '/tasks'
  },
  {
    path: '/tasks/:id/training',
    name: 'training',
    component: () => import(/* webpackPreload: true */ '@/views/Tasks/Training.vue')
  },
  {
    path: '/tasks/:id/images',
    name: 'images',
    component: () => import('@/views/Tasks/Images.vue')
  },
  {
    path: '/tasks/:id/history',
    name: 'history',
    component: () => import('@/views/Tasks/History.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const isGuest = !Vue.$cookies.isKey('refresh_token')
  if (isGuest && !to.meta.isAuthPage) next('/signin')
  else if (!isGuest && to.meta.isAuthPage) next('/tasks')
  next()
})

export default router
